import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "contexts/AuthContext";
import FullPageSpinner from "components/auth/FullPageSpinner";

export default function ProtectedRoute({ allowedRoles, allowedTenants }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Identity is resolved by an API call, so "not known yet" is a real state and
  // is not the same as "signed out". Redirecting here would bounce every
  // refresh to the sign-in page and then back again.
  if (loading) return <FullPageSpinner />;

  if (!user) {
    // Remember where they were headed so sign-in can return them there rather
    // than dumping them on the default route.
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Signed in but not permitted is a different situation from signed out.
  // Sending these to sign-in reads as "your session expired", which is wrong
  // and invites the user to log in again to no effect.
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  if (allowedTenants && !allowedTenants.includes(user.tenant)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
